module.exports = __webpack_public_path__ + "img/selected3-min.b68b2348.png";